/**
 * FE mirror of config/quick_valuation.php `county_modes` — which serving
 * modes each county offers in Kiirhindamine ('comparables' | 'direct'; an
 * empty list = no model coverage). Comparables first, matching the backend's
 * comparables-first resolution. Used by the admin county-access UI to build
 * one row per (county, mode); the backend config stays the source of truth
 * for actual serving decisions and carries the per-mode model pins.
 */
export const COUNTY_MODES = {
  Harjumaa: ['comparables'],
  Hiiumaa: ['direct'],
  'Ida-Virumaa': ['direct'],
  Jõgevamaa: ['direct'],
  Järvamaa: ['direct'],
  Läänemaa: ['direct'],
  'Lääne-Virumaa': ['direct'],
  Põlvamaa: ['direct'],
  Pärnumaa: ['comparables', 'direct'],
  Raplamaa: ['direct'],
  Saaremaa: ['direct'],
  Tartumaa: ['comparables', 'direct'],
  Valgamaa: ['direct'],
  Viljandimaa: ['direct'],
  Võrumaa: ['direct'],
}

/** Stable identity of one entitlement row. */
export const countyModeKey = (county, mode) => `${county}|${mode}`

/**
 * Rows whose backend pin carries a subject qualifier (served to qualifying
 * subjects only — Pärnumaa comparables = the dense Pärnu city core, RED-262).
 * The user matrix gets this from CountyAccess::matrixFor's `qualified`; the
 * company dialog builds its rows client-side and mirrors it from here.
 */
export const QUALIFIED_COUNTY_MODES = new Set([countyModeKey('Pärnumaa', 'comparables')])
